import { render, staticRenderFns } from "./institutions.vue?vue&type=template&id=7e144692&"
import script from "./institutions.vue?vue&type=script&lang=js&"
export * from "./institutions.vue?vue&type=script&lang=js&"
import style0 from "./institutions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports